<div [className]="className" [style]="styleName">
    
      <label [className]="labelClass"  for="input_{{id}}" 
             [style]="labelStyle"     
             [translateParams]="labelParam" translate>
             <span [innerHTML]="label|translate:labelParam"></span>
             <ng-content></ng-content>
      </label>

      <div *ngIf="hintText" [className]="hintClass"  [innerHTML]="hintText|translate:hintParam"
                                [style]="hintlStyle"></div>

      
          <input type="{{type}}"  id="input_{{id}}"
                 [className]="inputClass"
                 [style]="inputStyle"
                 [attr.disabled]="disable?true:null"
                 [placeholder]="placeholder"
                 [(ngModel)]="input"

                 [size]="size"
                 [maxlength]="max"

                  oninput="this.value=this.value.slice(0,this.maxLength)"
                  (input)="valueChanged()"
                  (blur)="onBlur()"
                 (focus)="onFocus()"
                 (keypress)="onKeyPress($event)"
                 attr.aria-describedby="error_{{id}}"/>
      

       <div [hidden]="!error" 
            [className]="errorClass" 
            [style]="errorStyle" id="error_{{id}}">
                  <b>{{!error? '':'error.prefix'| translate}}</b>
                  <span class="" [innerHTML]="error|translate:errorParam" ></span>
       </div>
</div>




